export default "__VITE_ASSET__B3rot2$n__"